import React from 'react';

interface VerticalScreenFooterProps {
  logo: string;
  phone?: string;
  website?: string;
  backgroundColor?: string;
  textColor?: string;
}

function VerticalScreenFooter({
  logo,
  phone,
  website,
  backgroundColor = '#00AEEF',
  textColor = '#fff',
}: VerticalScreenFooterProps) {
  return (
    <footer
      className="flex items-center justify-between px-[4vw] py-[1vh]"
      style={{ color: textColor, backgroundColor }}
    >
      <div className="flex flex-col justify-center">
        {phone && (
          <p
            className="text-[4.5vw] font-extrabold leading-tight"
            style={{ color: textColor }}
          >
            {phone}
          </p>
        )}
        {website && (
          <p
            className={`${phone ? 'text-[3vw]' : 'text-[5vw]'} font-bold leading-tight`}
            style={{ color: textColor }}
          >
            {website}
          </p>
        )}
      </div>
      <img src={logo} alt="Logo" className="h-[8vh] w-[8vh] object-contain" />
    </footer>
  );
}

export default VerticalScreenFooter;
